export default __webpack_public_path__ + "static/media/dune_filtration.730d23e5.png";